import {
  IFilterConfigChildren,
  IFilterConfigItem,
  IFilterItems
} from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { getSelectFormattedValue } from '@/bundles/GroupFilters/helpers/formatters/inputs';

export const getMultiplySelectFormattedValue = (value: string[] | number[], configFilter: IFilterConfigItem | IFilterConfigChildren): string => {
  if ('children' in configFilter) {
    return value.map((val) => getSelectFormattedValue(val, configFilter.items as IFilterItems)).join(', ');
  }

  const isFilteredExcluded = configFilter.name === 'filteredItems' || configFilter.name === 'excludedItems';

  return isFilteredExcluded ? 'True' : getSelectFormattedValue(value, configFilter.items as IFilterItems);
}
